// This app's error-handling middleware shapes a backend failure as
// `{"error": {id, type, code, message, version}}` -- not a plain string.
// Storing that raw object directly as `state.error` and rendering
// `{error}` in a component crashes React ("Objects are not valid as a
// React child"), which is exactly what happened on /stocks-overview
// whenever a market-data category legitimately 503s. Always extract a
// real string here instead.
//
// Promoted out of marketSnapshotSlice.js (where it was first written) so
// other slices reading the same error envelope don't duplicate it.
export const extractErrorMessage = (payload, fallbackMessage) => {
  if (typeof payload === 'string' && payload) return payload;
  if (payload?.error?.message) return payload.error.message; // this app's real envelope
  if (typeof payload?.detail === 'string') return payload.detail; // plain HTTPException shape
  if (typeof payload?.message === 'string') return payload.message;
  return fallbackMessage || 'Something went wrong. Please try again.';
};
